var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Auth',{on:{"loggedIn":_vm.onLoggedIn,"loginFailed":_vm.onFailedAuthentication}},[_c('div',{staticClass:"wrap-application"},[(_vm.uid)?_c('ModuleApplication'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }